import classNames from 'classnames'
import { useTranslation } from 'next-i18next'

import { STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'
import { generateEDDLabel } from '@src/quince-site-common/src/hooks/edd/utils/edd.utils'
import { EDDDetails } from '@src/quince-site-common/src/services/eddService/eddService.types'

import { TSocialProofData } from '../product-card.types'

import styles from './product-card-footer.module.scss'
export function BottomTagComponent({
  isWhiteGloveDelivery,
  eddDetails,
  socialProofData,
  isOOS,
  hideUrgencyTags,
}: {
  isWhiteGloveDelivery?: boolean
  eddDetails?: EDDDetails
  socialProofData?: TSocialProofData
  isOOS?: boolean
  hideUrgencyTags?: boolean
}) {
  const { t: tCommon } = useTranslation('common')
  const eddLabel = generateEDDLabel(eddDetails, tCommon)
  const { experimentBucket: eddBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.EDD)
  const isEDDExpEnabled = eddBucket !== STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.EDD].buckets?.control
  const { experimentBucket: urgencyTagsBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.URGENCY_TAGS)

  const showUrgencyTags =
    urgencyTagsBucket !== STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.URGENCY_TAGS].buckets?.control &&
    !hideUrgencyTags

  return (
    <>
      {showUrgencyTags && socialProofData?.soldRecentlyTag && (
        <div className={styles.soldRecentlyTag}>{socialProofData.soldRecentlyTag}</div>
      )}
      {eddLabel && isEDDExpEnabled && <div className={classNames(styles.bottomTag, styles.eddLabel)}>{eddLabel}</div>}
      {isWhiteGloveDelivery ? <div className={styles.whiteglove}>{tCommon('free_white_glove_delivery')}</div> : null}
      {showUrgencyTags && socialProofData?.stockTag && !isOOS && (
        <div className={styles.stockTag}>{socialProofData.stockTag}</div>
      )}
    </>
  )
}
